import { render, staticRenderFns } from "./crudServices.vue?vue&type=template&id=7f1af1b2&scoped=true&"
import script from "./crudServices.vue?vue&type=script&lang=js&"
export * from "./crudServices.vue?vue&type=script&lang=js&"
import style0 from "./crudServices.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudServices.vue?vue&type=style&index=1&id=7f1af1b2&scoped=true&lang=css&"
import style2 from "./crudServices.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1af1b2",
  null
  
)

export default component.exports